<template>
  <div class="product-filter">
    <div class="filter-group">
      <input
        type="text"
        v-model="searchParams.keyword"
        placeholder="搜索产品标题"
        class="search-input"
      />
    </div>
    <div class="filter-group">
      <select v-model="searchParams.tag" class="filter-select">
        <option value="">所有标签</option>
        <option value="首页不展示">首页不展示</option>
        <option value="首页展示">首页展示</option>
        <!-- <option value="推荐">推荐</option> -->
      </select>
    </div>
    <div class="filter-group">
      <select v-model="searchParams.status" class="filter-select">
        <option value="all">所有状态</option>
        <option value="active">启用</option>
        <option value="inactive">禁用</option>
      </select>
    </div>
    <div class="filter-group">
      <button @click="handleSearch" class="search-btn">搜索</button>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';

const emit = defineEmits(['search']);
const searchParams = ref({
  keyword: '',
  tag: '',
  status: 'all'
});

const handleSearch = () => {
  emit('search', { ...searchParams.value });
};
</script>

<style scoped>
.product-filter {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
}

.search-input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 200px;
}

.filter-select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.search-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
</style>